import { defineStore } from 'pinia'
import { ref } from 'vue'

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  // Fallback
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export const useUserStore = defineStore('user', () => {
  // State
  const sessionId = ref('')
  const ipAddress = ref('')
  const city = ref('')
  const state = ref('')
  const zip = ref('')

  // URL params
  const affId = ref('')
  const lpS1 = ref('')
  const lpS2 = ref('')
  const lpS3 = ref('')
  const lpS4 = ref('')
  const lpS5 = ref('')

  // Actions
  function initSession() {
    const key = 'session_id'
    let saved = localStorage.getItem(key)

    if (!saved) {
      saved = generateUUID()
      localStorage.setItem(key, saved)
    }

    sessionId.value = saved
  }

  function setGeolocation(geo: { ip: string; city: string; state: string; zip: string }) {
    ipAddress.value = geo.ip
    city.value = geo.city
    state.value = geo.state
    zip.value = geo.zip
  }

  function parseUrlParams() {
    const params = new URLSearchParams(window.location.search)

    affId.value = params.get('aff_id') || params.get('affid') || ''
    lpS1.value = params.get('s1') || params.get('lp_s1') || ''
    lpS2.value = params.get('s2') || params.get('lp_s2') || ''
    lpS3.value = params.get('s3') || params.get('lp_s3') || ''
    lpS4.value = params.get('s4') || params.get('lp_s4') || ''
    lpS5.value = params.get('s5') || params.get('lp_s5') || ''
  }

  function init() {
    initSession()
    parseUrlParams()
  }

  return {
    // State
    sessionId,
    ipAddress,
    city,
    state,
    zip,
    affId,
    lpS1,
    lpS2,
    lpS3,
    lpS4,
    lpS5,
    // Actions
    initSession,
    setGeolocation,
    parseUrlParams,
    init,
  }
})
